import * as React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Flex } from "@rebass/grid";
import * as R from "ramda";

import { ClientAttribute } from "../../../types/models";
import { ThunkDispatch } from "../../../types/redux";
import { RootState } from "../../../store/reducer";

import { clientAttributeActions } from "../../../store/modules/client_attributes";
import DimensionCreator from "./DimensionCreator";
import DimensionColumns from "./DimensionColumns";
import {
  ClientAttributeColumn,
  DEFAULT_CLIENT_ATTRIBUTE_NAME,
} from "./ClientAttributeColumn";

interface IProps extends RouteComponentProps<any> {
  dispatch: ThunkDispatch;
  clientAttributes: Array<Partial<ClientAttribute>>;
  isEditingView: boolean;
  clientId: number;
}

class ClientInitialAttributesEditor extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.isValidAttributeName = this.isValidAttributeName.bind(this);

    this.state = { isReordering: false };
  }

  public render() {
    const isAddingAttribute = this.props.clientAttributes.some(
      (a) => DEFAULT_CLIENT_ATTRIBUTE_NAME === a.Name
    );

    return (
      <Flex style={{ maxHeight: "calc(100vh - 132px)", overflowY: "auto" }}>
        <DimensionColumns noTabBarHeight>
          {(this.props.clientAttributes ?? []).map(
            (attribute: any, index: number) => (
              <div key={index}>
                <ClientAttributeColumn
                  key={`${attribute.id}-${attribute.Name}`}
                  attribute={attribute}
                  validateName={this.isValidAttributeName}
                  isEditingView={this.props.isEditingView}
                  dispatch={this.props.dispatch}
                  clientId={this.props.clientId}
                />
              </div>
            )
          )}
          <DimensionCreator
            text="Add Attribute"
            onClick={this.createAttribute}
            disabled={isAddingAttribute}
          />
        </DimensionColumns>
      </Flex>
    );
  }

  private isValidAttributeName = (newName: string): boolean => {
    return !(this.props.clientAttributes ?? []).some(
      (attr: Partial<ClientAttribute>) => {
        return (
          R.toLower(attr.Name || DEFAULT_CLIENT_ATTRIBUTE_NAME) ===
          R.toLower(newName)
        );
      }
    );
  };
  private createAttribute = () => {
    this.props.dispatch(
      clientAttributeActions.addClientAttribute({
        Name: DEFAULT_CLIENT_ATTRIBUTE_NAME,
      })
    );
  };
}
const mapStateToProps = (state: RootState) => ({
  clientAttributes: state.clientAttributes,
});
export default withRouter(
  connect(mapStateToProps)(ClientInitialAttributesEditor)
);
